/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useLazyQuery, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import {
  createPCategory,
  deletePCategory,
  updatePCategory,
} from '../graphql/mutation';
import { getPCategories } from '../graphql/query';

export default () => {
  const [getDeparts, catpData]: any = useLazyQuery(getPCategories);

  const [addPCategory] = useMutation(createPCategory, {
    refetchQueries: [{ query: getPCategories }],
  });
  const [editPCategory] = useMutation(updatePCategory, {
    refetchQueries: [{ query: getPCategories }],
  });
  const [removePCategory] = useMutation(deletePCategory, {
    refetchQueries: [{ query: getPCategories }],
  });

  useEffect(() => {
    getDeparts();
  }, [getDeparts]);

  const pcategories = catpData?.data?.['getPCategories']?.data || [];
  const refreshpcategories = () => catpData?.refetch();
  return {
    pcategories,
    addPCategory,
    editPCategory,
    removePCategory,
    refreshpcategories,
    loading: catpData?.loading,
  };
};
